import { Injectable } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { IMfaInputDialogForm } from '../models/mfa-input-dialog-form.interface';

@Injectable()
export class MfaInputDialogFormService {
    public formGroup: FormGroup<IMfaInputDialogForm>;

    public constructor(private readonly formBuilder: FormBuilder) {
        this.initForm();
    }

    private initForm(): void {
        this.formGroup = this.formBuilder.group({
            mfa: new FormControl<string | null>(null),
        });
    }
}
